import confetti from 'canvas-confetti';
import { toast } from 'sonner';

export const celebratePaymentSuccess = (creditsAdded) => {
  // Fire confetti
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  const interval = setInterval(function() {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);
    
    // Fire from left
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
    });
    
    // Fire from right
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
    });
  }, 250);

  // Show success toast
  toast.success(
    `🎉 Payment Successful!`,
    {
      description: `${creditsAdded} credits added to your account. Thank you!`,
      duration: 5000,
    }
  );
};

export const showLowCreditWarning = (currentCredits) => {
  toast.warning(
    '⚠️ Low Credit Balance',
    {
      description: `You have ${currentCredits} credits remaining. Consider topping up!`,
      duration: 4000,
    }
  );
};

export const checkAndWarnLowCredits = (credits, threshold = 10) => {
  if (credits <= threshold && credits > 0) {
    showLowCreditWarning(credits);
    return true;
  }
  return false;
};
